import { render } from "./CurrencyDetails.vue?vue&type=template&id=0a3b22b7&ts=true"
import script from "./CurrencyDetails.vue?vue&type=script&lang=ts"
export * from "./CurrencyDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__